import React, { useState } from "react";
import Contacts from "@/pages/contacts";
import Australiaskilledmigrationvisaimport from "@/pages/australiaskilledmigrationvisaimport";
const Australiaskilledmigrationvisa = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAnswer = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <div>
        <div className="h-98 relative w-full">
          <img
            src="/australiya.jpg" // Replace with the correct path to your image
            alt="Canada Immigration"
            className="h-96 w-full object-cover"
          />
          {/* <div className="absolute bottom-5 left-5 text-3xl font-bold text-[#011473] drop-shadow-md">
          Australia Skilled Migration Visa - MARA Registered
          </div> */}
        </div>
      </div>
      <div className="text-center text-3xl font-bold text-[#011473] drop-shadow-md mt-10 mx-auto md:ml-32 w-full md:w-3/4">
  Visa World – Your Pathway to Australia
</div>

      <div className="flex flex-col items-center space-x-0 py-20 lg:flex-row lg:space-x-4">
        {/* Left Section: Image */}

        <div className="mb-8 flex justify-center lg:mb-0 lg:w-1/2">
          <img
            src="/pathway.jpg" // Replace with the correct path to your image
            alt="Canada Skilled Migration Documents"
            className="w-98 h-96 rounded object-cover shadow-lg"
          />
        </div>

        {/* Right Section: Text */}
        <div className="space-y-4 lg:w-1/2">
  <div className="flex items-center">
    <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
      </svg>
    </div>
    <span className="ml-3 font-medium text-gray-700">
      <a className="text-black font-bold">Skilled Migration Visa:</a> Offering a streamlined process for skilled professionals to move to Australia.
    </span>
  </div>

  <div className="flex items-center">
    <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
      </svg>
    </div>
    <span className="ml-3 font-medium text-gray-700">
    <a className="text-black font-bold">  Expert Guidance: </a>Our team provides personalized assistance at every stage of your application.
    </span>
  </div>

  <div className="flex items-center">
    <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
      </svg>
    </div>
    <span className="ml-3 font-medium text-gray-700">
    <a className="text-black font-bold"> Eligibility Criteria: </a> We help you understand the specific requirements based on your occupation and skills.
    </span>
  </div>

  <div className="flex items-center">
    <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
      </svg>
    </div>
    <span className="ml-3 font-medium text-gray-700">
    <a className="text-black font-bold"> Required Documents:</a> We guide you through the necessary documentation to ensure a complete and accurate application.
    </span>
  </div>

  <div className="flex items-center">
    <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
      </svg>
    </div>
    <span className="ml-3 font-medium text-gray-700">
    <a className="text-black font-bold">Successful Application:</a> We work to maximize your chances of success and a smooth transition to Australia.
    </span>
  </div>
</div>

      </div>
      <Australiaskilledmigrationvisaimport />
      
      <div className="flex w-full flex-col items-center justify-center py-20">
        {isOpen && (
          <div className="mb-6 w-3/4 items-center justify-center rounded-md text-black bg-gray-100 p-4 text-lg shadow-md">
            <p>
              <br />
              <strong>Overview of Canada’s Immigration Program:</strong> Canada, consisting of 10 provinces and 3 territories, is known for its dynamic approach towards skilled immigration. The <strong>Federal Skilled Worker Program (FSWP)</strong> offers skilled professionals across various sectors the opportunity to immigrate to Canada and secure permanent residence.
              <br />
              <strong>Support for Global Talent:</strong> Canada welcomes individuals with diverse skills, contributing to its economic, intellectual and cultural growth. The country’s commitment to attracting global talent has helped enhance its workforce and drive innovation.
              <br />
              <strong>Federal Skilled Worker Program (FSWP) Under Express Entry:</strong> Since 2008, the FSWP has been a key part of Canada’s <strong>Express Entry System</strong>, designed to fast-track immigration for skilled workers. The program targets professionals with recognized qualifications, work experience, language proficiency and other essential factors for immigration.
              <br />
              <strong>Eligibility Criteria for FSWP:</strong> Candidates must meet specific criteria including education, work experience, language proficiency and age. Applicants need to score at least <strong>67 points</strong> out of 100 based on these factors.
              <br />
              <strong>Expression of Interest System:</strong> Candidates can enter the <strong>Expression of Interest (EOI)</strong> system, where they are ranked according to factors such as age, qualifications, work experience and language skills. The highest-ranked candidates are then invited to apply for permanent residence.
              <br />
              <strong>Benefits for Skilled Workers:</strong> The Federal Skilled Worker Program provides a significant opportunity for experienced professionals to gain permanent residency in Canada. By fulfilling the program’s requirements, candidates can contribute to Canada's growth and integration within its diverse workforce.
              <br />
              <strong>Streamlining the Process:</strong> Hiring expert immigration consultants can simplify and expedite the application process, ensuring that all necessary documentation and procedures are followed efficiently.
              <br />
            </p>
          </div>
        )}
        <button
          onClick={toggleAnswer}
          className="flex w-2/2 md:w-1/2 items-center justify-center rounded-full bg-blue-600 px-6 py-3 text-center text-md font-semibold text-white transition duration-300 ease-in-out hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
        >
          Canada Skilled Immigration – Federal Skilled Worker Program (FSWP)
          <svg
            className={`ml-3 h-4 w-4 transform transition-transform duration-300 ${
              isOpen ? "rotate-180" : ""
            }`}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M12 5v14M5 12l7 7 7-7"></path>
          </svg>
        </button>
      </div>

      | 
      <Contacts />
    </>
  );
};

export default Australiaskilledmigrationvisa;
